import React, { useState } from "react";
import { useDebounce } from "react-use";
import useQueryParams from "../hooks/useQueryParams";

const SearchInputWithQueryState = ({
  queryKey = "search",
  addOrUpdateAdditionalParams = {},
  debounceDelayMS = 3000,
  ...res
}) => {
  const { params, addOrUpdateParams, removeParam } = useQueryParams();
  const [searchValue, setSearchValue] = useState(params[queryKey] || "");

  const updateSearchParam = () => {
    if (searchValue === "") removeParam(queryKey);
    else if (searchValue === params[queryKey]) return;
    else addOrUpdateParams({ [queryKey]: searchValue, ...addOrUpdateAdditionalParams });
  };

  useDebounce(updateSearchParam, debounceDelayMS, [searchValue]);

  return (
    <input
      value={searchValue}
      onChange={({ target }) => setSearchValue(target.value)}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          updateSearchParam();
        }
      }}
      type="search"
      {...res}
    />
  );
};

export default SearchInputWithQueryState;
